import React from "react";
import { useStore } from "store";
import { cn } from "helpers/style";
import styles from "./Address.module.scss";

const Address: React.FC = () => {
  const { settings } = useStore();

  return (
    <div className={styles.footerAddress}>
      <p
        className={cn([
          styles.footerAddressText,
          styles.footerAddressTextPrimary,
        ])}
      >
        © {settings.year} ООО «Здравсити»,{" "}
        <span className={styles.footerAddressBr} /> ИНН 9715402032, ОГРН
        1217700264561
      </p>
      <p className={styles.footerAddressText}>
        Адрес места нахождения: 127282, г. Москва, ул. Чермянская, д. 2, стр. 1,
        этаж 8, помещ. 1, ком. 9
      </p>
    </div>
  );
};

export default Address;
